import React, { useState } from 'react';
import { Globe } from 'lucide-react';
import { useCurrency } from '../context/CurrencyContext';
import { motion, AnimatePresence } from 'framer-motion';

const CurrencySwitcher = () => {
  const { currency, setCurrency, currencies } = useCurrency();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        data-testid="currency-switcher-btn"
        className="flex items-center space-x-2 text-sand hover:text-gold transition-colors px-3 py-2 rounded-lg hover:bg-sand/10"
      >
        <Globe size={18} />
        <span className="font-body text-sm font-medium">{currency}</span>
      </button>

      <AnimatePresence>
        {isOpen && (
          <>
            <div
              className="fixed inset-0 z-40"
              onClick={() => setIsOpen(false)}
            />
            <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-xl border border-border z-50"
              data-testid="currency-dropdown"
            >
              <div className="p-2">
                <p className="px-3 py-2 text-xs font-body font-semibold text-muted-foreground uppercase tracking-wider">
                  Select Currency
                </p>
                {Object.entries(currencies).map(([code, { symbol, name }]) => (
                  <button
                    key={code}
                    onClick={() => {
                      setCurrency(code);
                      setIsOpen(false);
                    }}
                    data-testid={`currency-option-${code}`}
                    className={`w-full text-left px-3 py-2 rounded-md font-body text-sm transition-colors ${
                      currency === code
                        ? 'bg-navy text-gold font-semibold'
                        : 'text-navy hover:bg-muted'
                    }`}
                  >
                    <span className="font-semibold">{symbol}</span> {code} - {name}
                  </button>
                ))}
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </div>
  );
};

export default CurrencySwitcher;